import React, { useEffect, useMemo, useState } from "react";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";



import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import MasterV2 from "../MasterV2";

import { LoadingDiv, SweetAlertShow } from "../../master/Master";

import { studentAttendanceFullReport } from "../../../api/Attendance";



const safeNumber = (value) => Number.isFinite(Number(value)) ? Number(value) : 0;

const pad = (value) => String(value).padStart(2, "0");

const today = () => {

  const d = new Date();

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

};

const readableDate = (value) => {

  if (!value) return "-";

  const d = new Date(`${String(value).slice(0, 10)}T00:00:00`);

  if (Number.isNaN(d.getTime())) return value;

  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

};

const readableTime = (value) => {

  if (!value) return "-";

  const parts = String(value).split(":");

  if (parts.length < 2) return value;

  const d = new Date();

  d.setHours(Number(parts[0]), Number(parts[1]), Number(parts[2] || 0));

  return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });

};

const initials = (name) => String(name || "?").trim().split(/\s+/).slice(0, 2).map((x) => x[0]?.toUpperCase()).join("");

const percentClass = (value) => safeNumber(value) < 40 ? "critical" : safeNumber(value) < 60 ? "danger" : safeNumber(value) < 75 ? "warning" : "good";



export default function StudentAttendanceFullReport() {

  const { studentId } = useParams();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState(null);

  const [sessions, setSessions] = useState([]);

  const [filters, setFilters] = useState({

    session_id: searchParams.get("session_id") || "",

    from_date: searchParams.get("from_date") || "",

    to_date: searchParams.get("to_date") || today(),

    month: searchParams.get("month") || "",

  });



  useEffect(() => {

    try {

      const list = JSON.parse(localStorage.getItem("sessions") || "[]");

      setSessions(Array.isArray(list) ? list : []);

      if (!filters.session_id) {

        const active = (Array.isArray(list) ? list : []).find((x) => Number(x?.status) === 1);

        if (active?.id) setFilters((p) => ({ ...p, session_id: String(active.id) }));

      }

    } catch { setSessions([]); }

    // eslint-disable-next-line

  }, []);



  const loadReport = async () => {

    if (!studentId || !filters.session_id) return;

    setLoading(true);

    try {

      const params = new URLSearchParams();

      params.set("session_id", filters.session_id);

      if (filters.from_date) params.set("from_date", filters.from_date);

      if (filters.to_date) params.set("to_date", filters.to_date);

      if (filters.month) params.set("month", filters.month);

      const response = await studentAttendanceFullReport(studentId, params.toString());

      if (!response?.data?.status) throw new Error(response?.data?.message || "Unable to load report.");

      setData(response?.data?.data || null);

    } catch (error) {

      setData(null);

      SweetAlertShow("error", "Attendance Report", error?.response?.data?.message || error?.message || "Unable to load student attendance report.");

    } finally { setLoading(false); }

  };



  useEffect(() => { loadReport(); /* eslint-disable-next-line */ }, [studentId, filters.session_id, filters.from_date, filters.to_date, filters.month]);



  const student = data?.student || {};

  const summary = data?.summary || {};

  const monthly = Array.isArray(data?.monthly_summary) ? data.monthly_summary : [];

  const yearly = Array.isArray(data?.yearly_summary) ? data.yearly_summary : [];

  const daily = Array.isArray(data?.daily_details) ? data.daily_details : [];



  const selectedSession = useMemo(() => sessions.find((x) => String(x?.id) === String(filters.session_id)), [sessions, filters.session_id]);

  const sessionLabel = data?.session?.label || selectedSession?.session || selectedSession?.title || "-";



  const printReport = () => window.print();



  return (

    <>

      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar attendance-dashboard">
      <div className="layout-container">

        <div className="no-print">
          <Header />
        </div>

        <div className="layout-page student-full-report-layout">

          <div className="no-print">
            <Nav />
          </div>

          <div className="content-wrapper student-full-content-wrapper">
            <div className="container-fluid flex-grow-1 container-p-y student-full-container">

              <div className="no-print student-full-master-v2">
                <MasterV2 />
              </div>

              <div className="">



                <div className="sfr-header no-print">

                  <div className="sfr-header-left">

                    <button className="sfr-back" type="button" onClick={() => navigate(-1)}><i className="ri-arrow-left-line" /></button>

                    <div><h4>Student Attendance Report</h4><p>Session, monthly and daily attendance details</p></div>

                  </div>

                  <button className="sfr-print" type="button" onClick={printReport}><i className="ri-printer-line" /> Print Report</button>

                </div>



                <div className="sfr-student-card">

                  <div className="sfr-student-main">

                    <span className="sfr-avatar">{initials(student?.name)}</span>

                    <div><h3>{student?.name || "Student"}</h3><p>{student?.registration_no || "-"} • {student?.batch_name || "-"} • {student?.course_name || "-"}</p></div>

                  </div>

                  <div className="sfr-student-meta">

                    <div><span>Father</span><strong>{student?.father_name || "-"}</strong></div>

                    <div><span>Mobile</span><strong>{student?.phone || "-"}</strong></div>

                    <div><span>Session</span><strong>{sessionLabel}</strong></div>

                  </div>

                </div>



                <div className="sfr-filter-card no-print">

                  <div className="sfr-field"><label>Session</label><select value={filters.session_id} onChange={(e) => setFilters((p) => ({ ...p, session_id: e.target.value, month: "" }))}><option value="">Select Session</option>{sessions.map((s) => <option key={s.id} value={s.id}>{s.session || s.title}{Number(s.status) === 1 ? " - Active" : ""}</option>)}</select></div>

                  <div className="sfr-field"><label>From Date</label><input type="date" value={filters.from_date} onChange={(e) => setFilters((p) => ({ ...p, from_date: e.target.value }))} /></div>

                  <div className="sfr-field"><label>To Date</label><input type="date" value={filters.to_date} max={today()} onChange={(e) => setFilters((p) => ({ ...p, to_date: e.target.value }))} /></div>

                  <div className="sfr-field"><label>Daily Details Month</label><select value={filters.month} onChange={(e) => setFilters((p) => ({ ...p, month: e.target.value }))}><option value="">All Months</option>{monthly.map((m) => <option key={m.month} value={m.month}>{m.month_label}</option>)}</select></div>

                </div>



                <div className="sfr-print-title"><h2>Student Attendance Report</h2><p>{student?.name} • {student?.registration_no} • Session {sessionLabel}</p></div>



                <div className="sfr-summary-grid">

                  <div className="sfr-summary-card present"><span><i className="ri-checkbox-circle-line" /></span><div><small>Present Days</small><strong>{safeNumber(summary.present_days)}</strong></div></div>

                  <div className="sfr-summary-card absent"><span><i className="ri-close-circle-line" /></span><div><small>Absent Days</small><strong>{safeNumber(summary.absent_days)}</strong></div></div>

                  <div className="sfr-summary-card marked"><span><i className="ri-calendar-check-line" /></span><div><small>Marked Days</small><strong>{safeNumber(summary.marked_days)}</strong></div></div>

                  <div className={`sfr-summary-card ${percentClass(summary.attendance_percentage)}`}><span><i className="ri-percent-line" /></span><div><small>Attendance</small><strong>{safeNumber(summary.attendance_percentage).toFixed(1)}%</strong></div></div>

                  <div className="sfr-summary-card streak"><span><i className="ri-alarm-warning-line" /></span><div><small>Current Absent Streak</small><strong>{safeNumber(summary.current_absent_streak)} Days</strong></div></div>

                  <div className="sfr-summary-card streak"><span><i className="ri-bar-chart-box-line" /></span><div><small>Longest Absent Streak</small><strong>{safeNumber(summary.longest_absent_streak)} Days</strong></div></div>

                </div>



                <div className="sfr-date-strip">

                  <div><span>Report From</span><strong>{readableDate(data?.session?.from_date)}</strong></div>

                  <div><span>Report To</span><strong>{readableDate(data?.session?.to_date)}</strong></div>

                  <div><span>Last Present</span><strong>{readableDate(summary.last_present_date)}</strong></div>

                  <div><span>Last Absent</span><strong>{readableDate(summary.last_absent_date)}</strong></div>

                </div>



                <div className="sfr-section-card">

                  <div className="sfr-section-head"><div><h5>Monthly Attendance Summary</h5><p>Month-wise present, absent and attendance percentage</p></div></div>

                  <div className="sfr-table-wrap"><table className="sfr-table"><thead><tr><th>Month</th><th className="text-center">Present</th><th className="text-center">Absent</th><th className="text-center">Marked</th><th>Attendance</th><th className="no-print">Details</th></tr></thead><tbody>{monthly.length ? monthly.map((row) => { const pc = percentClass(row.attendance_percentage); return <tr key={row.month}><td><strong>{row.month_label}</strong></td><td className="text-center"><span className="sfr-pill present">{row.present_days}</span></td><td className="text-center"><span className="sfr-pill absent">{row.absent_days}</span></td><td className="text-center">{row.marked_days}</td><td><div className="sfr-progress-line"><strong className={pc}>{safeNumber(row.attendance_percentage).toFixed(1)}%</strong><div><span className={pc} style={{ width: `${Math.min(100, safeNumber(row.attendance_percentage))}%` }} /></div></div></td><td className="no-print"><button className="sfr-view-month" type="button" onClick={() => setFilters((p) => ({ ...p, month: row.month }))}>View Days</button></td></tr>; }) : <tr><td colSpan="6" className="sfr-empty-cell">No monthly attendance found.</td></tr>}</tbody></table></div>

                </div>



                {yearly.length > 1 && <div className="sfr-section-card"><div className="sfr-section-head"><div><h5>Year-wise Summary</h5><p>Useful when the academic session crosses calendar years</p></div></div><div className="sfr-year-grid">{yearly.map((row) => <div key={row.year}><strong>{row.year}</strong><span>Present <b>{row.present_days}</b></span><span>Absent <b>{row.absent_days}</b></span><span>Attendance <b>{safeNumber(row.attendance_percentage).toFixed(1)}%</b></span></div>)}</div></div>}



                <div className="sfr-section-card">

                  <div className="sfr-section-head"><div><h5>Daily Attendance Details</h5><p>{filters.month ? `Showing ${filters.month}` : "Showing all marked attendance days in selected range"}</p></div><span>{daily.length} Records</span></div>

                  <div className="sfr-table-wrap"><table className="sfr-table daily"><thead><tr><th>Date</th><th>Day</th><th>Status</th><th>Check In</th><th>Check Out</th><th>Check In By</th><th>Check Out By</th></tr></thead><tbody>{daily.length ? daily.map((row) => { const present = Number(row.status) === 1; return <tr key={row.date}><td><strong>{readableDate(row.date)}</strong></td><td>{new Date(`${row.date}T00:00:00`).toLocaleDateString("en-IN", { weekday: "long" })}</td><td><span className={`sfr-status ${present ? "present" : "absent"}`}><i className={present ? "ri-checkbox-circle-line" : "ri-close-circle-line"} /> {row.status_label}</span></td><td>{readableTime(row.check_in_time)}</td><td>{readableTime(row.check_out_time)}</td><td>{row.check_in_by || "-"}</td><td>{row.check_out_by || "-"}</td></tr>; }) : <tr><td colSpan="7" className="sfr-empty-cell">No daily attendance records found.</td></tr>}</tbody></table></div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
            </div>

<style>{`

        .student-full-report-layout{min-width:0;width:100%}.student-full-report-page{max-width:1650px;margin:0 auto;color:#404552}.sfr-header,.sfr-student-card,.sfr-filter-card,.sfr-section-card,.sfr-date-strip{background:#fff;border:1px solid #e3e7ed;border-radius:12px;box-shadow:0 4px 18px rgba(31,45,61,.035)}

        .sfr-header{padding:15px 17px;display:flex;align-items:center;justify-content:space-between;margin-bottom:12px}.sfr-header-left{display:flex;align-items:center;gap:11px}.sfr-header h4{font-size:20px;margin:0;font-weight:800}.sfr-header p{font-size:12px;color:#8c94a0;margin:3px 0 0}.sfr-back{width:40px;height:40px;border:1px solid #e1e5eb;background:#fff;border-radius:9px;font-size:18px}.sfr-print{border:0;background:#696cff;color:#fff;border-radius:8px;padding:10px 14px;font-size:12px;font-weight:800;display:flex;align-items:center;gap:6px}

        .sfr-student-card{padding:17px;margin-bottom:12px;display:flex;align-items:center;justify-content:space-between;gap:20px}.sfr-student-main{display:flex;align-items:center;gap:12px}.sfr-avatar{width:52px;height:52px;flex:0 0 52px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#eef0ff;color:#696cff;font-size:16px;font-weight:900}.sfr-student-main h3{font-size:18px;margin:0;font-weight:850}.sfr-student-main p{font-size:11px;color:#858d99;margin:4px 0 0}.sfr-student-meta{display:grid;grid-template-columns:repeat(3,minmax(110px,1fr));gap:18px}.sfr-student-meta div{display:flex;flex-direction:column}.sfr-student-meta span,.sfr-date-strip span{font-size:10px;color:#959ca7}.sfr-student-meta strong,.sfr-date-strip strong{font-size:12px;margin-top:3px}

        .sfr-filter-card{padding:13px;margin-bottom:12px;display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}.sfr-field label{display:block;font-size:10px;font-weight:750;color:#737b87;margin:0 0 5px 2px}.sfr-field select,.sfr-field input{width:100%;min-height:39px;border:1px solid #dce1e7;border-radius:8px;padding:0 10px;background:#fff;color:#4c535e;font-size:11px;outline:none}

        .sfr-print-title{display:none}.sfr-summary-grid{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:9px;margin-bottom:12px}.sfr-summary-card{background:#fff;border:1px solid #e4e7ec;border-radius:11px;padding:13px;display:flex;align-items:center;gap:10px}.sfr-summary-card>span{width:38px;height:38px;flex:0 0 38px;border-radius:9px;display:flex;align-items:center;justify-content:center;font-size:18px;background:#f1f2f5}.sfr-summary-card>div{display:flex;flex-direction:column}.sfr-summary-card small{font-size:9px;color:#8f96a1}.sfr-summary-card strong{font-size:17px;margin-top:2px}.sfr-summary-card.present>span{background:#e9f8ef;color:#278b53}.sfr-summary-card.present strong{color:#278b53}.sfr-summary-card.absent>span,.sfr-summary-card.critical>span,.sfr-summary-card.danger>span{background:#ffeded;color:#d34849}.sfr-summary-card.absent strong,.sfr-summary-card.critical strong,.sfr-summary-card.danger strong{color:#d34849}.sfr-summary-card.good>span{background:#e9f8ef;color:#278b53}.sfr-summary-card.warning>span,.sfr-summary-card.streak>span{background:#fff3e2;color:#b9781c}

        .sfr-date-strip{display:grid;grid-template-columns:repeat(4,1fr);margin-bottom:12px;overflow:hidden}.sfr-date-strip>div{padding:11px 13px;border-right:1px solid #eceef2;display:flex;flex-direction:column}.sfr-date-strip>div:last-child{border-right:0}

        .sfr-section-card{overflow:hidden;margin-bottom:12px}.sfr-section-head{padding:12px 14px;border-bottom:1px solid #e9ecf0;display:flex;justify-content:space-between;align-items:center}.sfr-section-head h5{font-size:14px;margin:0;font-weight:850}.sfr-section-head p{font-size:10px;color:#9198a3;margin:3px 0 0}.sfr-section-head>span{font-size:10px;font-weight:800;background:#f1f2f5;padding:5px 8px;border-radius:6px}.sfr-table-wrap{overflow:auto}.sfr-table{width:100%;min-width:850px;border-collapse:collapse}.sfr-table th{background:#f7f8fa;color:#656d79;font-size:11px;font-weight:850;padding:11px 12px;border-bottom:1px solid #e2e6eb;text-align:left;white-space:nowrap}.sfr-table td{font-size:12px;color:#4d545f;padding:11px 12px;border-bottom:1px solid #eef0f3;vertical-align:middle}.sfr-table tbody tr:last-child td{border-bottom:0}.sfr-table tbody tr:hover{background:#fbfbfd}.sfr-pill{display:inline-flex;min-width:34px;justify-content:center;padding:5px 8px;border-radius:6px;font-weight:850}.sfr-pill.present{background:#e9f8ef;color:#278b53}.sfr-pill.absent{background:#ffeded;color:#d34849}.sfr-progress-line{min-width:170px}.sfr-progress-line>strong{font-size:11px}.sfr-progress-line>div{height:6px;background:#eceef2;border-radius:10px;overflow:hidden;margin-top:5px}.sfr-progress-line>div>span{display:block;height:100%;border-radius:10px}.good{color:#278b53!important}.warning{color:#b9781c!important}.danger,.critical{color:#d34849!important}.sfr-progress-line span.good{background:#3ca66a}.sfr-progress-line span.warning{background:#dca13c}.sfr-progress-line span.danger,.sfr-progress-line span.critical{background:#d34849}.sfr-view-month{border:1px solid #dfe3e8;background:#fff;color:#5d6570;border-radius:6px;padding:6px 9px;font-size:10px;font-weight:750}.sfr-status{display:inline-flex;align-items:center;gap:4px;padding:5px 8px;border-radius:6px;font-size:10px;font-weight:850}.sfr-status.present{background:#e9f8ef;color:#278b53}.sfr-status.absent{background:#ffeded;color:#d34849}.sfr-empty-cell{text-align:center!important;color:#989fa9!important;padding:25px!important}.sfr-year-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;padding:12px}.sfr-year-grid>div{border:1px solid #e6e9ed;border-radius:9px;padding:11px;display:grid;grid-template-columns:1.2fr repeat(3,1fr);gap:8px;align-items:center}.sfr-year-grid span{font-size:10px;color:#8a929e}.sfr-year-grid b{color:#4d545f;margin-left:4px}

        @media(max-width:1100px){.sfr-summary-grid{grid-template-columns:repeat(3,1fr)}.sfr-filter-card{grid-template-columns:repeat(2,1fr)}.sfr-student-card{align-items:flex-start;flex-direction:column}.sfr-student-meta{width:100%}}

        @media(max-width:700px){.student-full-report-page{padding-left:9px!important;padding-right:9px!important}.sfr-header{align-items:flex-start}.sfr-header p{display:none}.sfr-print{padding:10px}.sfr-print{font-size:0}.sfr-print i{font-size:16px}.sfr-filter-card{grid-template-columns:1fr 1fr}.sfr-summary-grid{grid-template-columns:repeat(2,1fr)}.sfr-date-strip{grid-template-columns:repeat(2,1fr)}.sfr-student-meta{grid-template-columns:repeat(2,1fr)}.sfr-year-grid{grid-template-columns:1fr}.sfr-year-grid>div{grid-template-columns:1fr 1fr}.sfr-table th{font-size:10px}.sfr-table td{font-size:11px}}

        @media print{.no-print,nav,.navbar,.layout-navbar{display:none!important}.student-full-report-page{max-width:none!important;padding:0!important}.sfr-print-title{display:block;margin-bottom:10px}.sfr-print-title h2{font-size:18px;margin:0}.sfr-print-title p{font-size:10px;margin:3px 0 0}.sfr-student-card,.sfr-section-card,.sfr-date-strip{box-shadow:none;border-color:#bbb}.sfr-summary-grid{grid-template-columns:repeat(6,1fr)}.sfr-summary-card{box-shadow:none;padding:8px}.sfr-summary-card>span{display:none}.sfr-summary-card strong{font-size:12px}.sfr-table{min-width:0}.sfr-table th,.sfr-table td{font-size:8px;padding:5px}.sfr-section-card{page-break-inside:avoid}@page{size:A4 landscape;margin:8mm}}

      
      /* APPLICATION SHELL + MASTER V2 */
      .attendance-dashboard{min-height:100vh;background:#f6f7fb}
      .attendance-dashboard .layout-container{min-height:100vh}
      .student-full-report-layout{min-width:0;width:100%;min-height:100vh}
      .student-full-content-wrapper{width:100%;min-width:0;background:#f6f7fb}
      .student-full-container{width:100%;max-width:100%;min-width:0;padding:16px 18px 40px}
      .student-full-master-v2{width:100%;min-width:0;margin-bottom:16px}
      .student-full-report-page{width:100%;max-width:1650px;min-width:0;margin:0 auto;color:#404552}
      @media(max-width:991.98px){.student-full-container{padding:12px}.student-full-master-v2{margin-bottom:12px}}
      @media(max-width:575.98px){.student-full-container{padding:10px}.student-full-master-v2{margin-bottom:10px}}
      @media print{.attendance-dashboard .no-print,.student-full-master-v2{display:none!important}.student-full-container{padding:0!important}}
`}</style>

    </>

  );

}
